import PropTypes from 'prop-types';
import React from 'react';

import Icon from '@wetransfer/transfer/component/icon/index';
import Tooltip from '@wetransfer/transfer/component/tooltip';
import { PRIMARY_BLUE } from '@wetransfer/transfer/constant/colors';
import I18n from '@wetransfer/transfer/modules/i18n';

export const LockedSender = ({ sender, disabled, onMouseEnter, onFocus }) => {
  return (
    <div
      className="uploader__locked-sender"
      onMouseEnter={onMouseEnter}
      onFocus={onFocus}
    >
      <span className="uploader__locked-sender-label">
        {I18n.t('transfer.form.from')}
      </span>
      <span
        role="button"
        className="uploader__locked-sender-email"
        tabIndex={disabled ? '-1' : '0'}
        title={sender}
      >
        {sender}
      </span>
      <Tooltip
        trigger="hover"
        content={I18n.t(
          'transfer.email-verification-success.verified_sender_tooltip_icon'
        )}
        offset={20}
        anchor="left"
      >
        <Icon
          type="CheckCircle"
          color={PRIMARY_BLUE}
          className="email-verification__success--checkmark"
        />
      </Tooltip>
    </div>
  );
};

LockedSender.propTypes = {
  sender: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onFocus: PropTypes.func,
};

export default React.memo(LockedSender);
